import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { API } from "@/lib/api";
import { Logo } from "@/components/Logo";
import { AIText } from "@/components/AIText";
import { ShieldCheck, AlertTriangle } from "lucide-react";

export default function SharedReport() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios.get(`${API}/shared/${token}`).then((r) => setData(r.data))
      .catch((e) => setError(e?.response?.data?.detail || "This shared report is unavailable."));
  }, [token]);

  return (
    <div className="min-h-screen hero-bg">
      <header className="border-b border-slate-100 bg-white">
        <div className="mx-auto max-w-3xl px-5 py-3.5 flex items-center justify-between">
          <Logo />
          <Link to="/" className="text-sm font-medium text-brandblue">coverguide.ai</Link>
        </div>
      </header>
      <div className="mx-auto max-w-3xl px-5 py-10">
        {error && (
          <div className="rounded-2xl bg-white border border-slate-100 card-shadow p-8 text-center text-slate-500">
            <AlertTriangle className="h-8 w-8 text-amber-500 mx-auto" />
            <p className="mt-3">{error}</p>
          </div>
        )}
        {data && (
          <div className="rounded-3xl bg-white border border-slate-100 card-shadow p-7">
            <span className="inline-flex items-center gap-2 rounded-full bg-teal-50 border border-teal-100 px-3 py-1 text-xs font-medium text-brandteal"><ShieldCheck className="h-3.5 w-3.5" /> Shared via CoverGuide</span>
            <h1 className="mt-4 font-display text-2xl font-semibold text-navy">{data.title}</h1>
            <p className="text-xs text-slate-400 mt-1">{new Date(data.created_at).toLocaleDateString()}</p>
            {data.meta && data.kind === "premium_change" && data.meta.percent !== undefined && (
              <p className="mt-3 text-sm font-medium text-navy">Change: {data.meta.difference >= 0 ? "+" : ""}${Number(data.meta.difference).toLocaleString()} ({data.meta.percent}%)</p>
            )}
            <div className="mt-4 border-t border-slate-100 pt-4"><AIText>{data.content}</AIText></div>
            <p className="mt-6 text-xs text-slate-400 border-t border-slate-100 pt-4">AI-assisted explanation from CoverGuide. Not an official insurer record. CoverGuide does not sell insurance.</p>
          </div>
        )}
        {!data && !error && <div className="flex justify-center py-16"><div className="h-8 w-8 rounded-full border-4 border-blue-200 border-t-brandblue animate-spin" /></div>}
      </div>
    </div>
  );
}
